import { render } from "./FlightsComponent.vue?vue&type=template&id=1740cb4c"
import script from "./FlightsComponent.vue?vue&type=script&lang=js"
export * from "./FlightsComponent.vue?vue&type=script&lang=js"

import "./FlightsComponent.vue?vue&type=style&index=0&id=1740cb4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__